import { useEffect, useState } from 'react';

import { elapsedLabel } from '@/features/calls/lib/call-presentation';

/** Le chrono d'un appel depuis `since` (horloge de ce téléphone), mis à jour chaque seconde. */
export function useElapsed(since: number | null): string | null {
  const [now, setNow] = useState(0);

  useEffect(() => {
    if (since === null) {
      return;
    }
    const tick = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(tick);
  }, [since]);

  return since === null ? null : elapsedLabel(now - since);
}
